'use strict';

const _ = require('lodash');

module.exports = {
    apply: apply,
    _findChanged: findChanged
};

function resetCollection(collection, models, options) {
    collection.reset(models, options);
}

function isEqual(a, b) {
    for (let i = 0; i < a.length; i++) {
        if (!_.isEqual(a[i].toJSON(), b[i].toJSON())) {
            return false;
        }
    }
    return true;
}

function handleIndenticalLength(collection, models, options) {

    if (isEqual(collection.toArray(), models)) {
        return;
    }

    // TODO Perf improvement - check if reordered

    return resetCollection(collection, models, options);
}

/*
 * Finds a single changed model
 */
function findChanged(shortArray, longArray) {
    let index;
    let j = 0;

    for (let i = 0; i < longArray.length; i++) {
        if (!shortArray[j]) {
            return (_.isUndefined(index) ? i : -1);
        }

        if (!_.isEqual(longArray[i].toJSON(), shortArray[j].toJSON())) {
            if (!_.isUndefined(index)) { // Multiple models changed
                return -1;
            }

            index = i;
        } else {
            j++;
        }
    }

    return index;
}

function handleAdd(collection, models, options) {
    const index = findChanged(collection.toArray(), models);

    if (index !== -1) {
        // Add at index
        collection.add(models[index], options);
    } else {
        resetCollection(collection, models, options);
    }
}


function handleRemove(collection, models, options) {
    const cArray = collection.toArray();
    const index = findChanged(models, cArray);

    if (index !== -1) {
        collection.remove(cArray[index], options);
    } else {
        resetCollection(collection, models, options);
    }
}

/*
 * Applies the models param to the collection, triggering the least impactful
 * event possible for rendering efficiency
 */
function apply(collection, models, options) {
    const diff = collection.length - models.length;

    if (!diff) {
        return handleIndenticalLength(collection, models, options);
    }

    if (diff === -1) {
        return handleAdd(collection, models, options);
    }

    if (diff === 1) {
        return handleRemove(collection, models, options);
    }

    resetCollection(collection, models, options);
}
